import apiClient from './Request'
import { baseUrls } from './../const'
import moment from 'moment'

export default {
  loginUser(user) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/user/login',
      data: user
    })
  },
  GetConfiguration() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/configurations/GetConfiguration'
    )
  },
  GetManufactures() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/manufacture/GetManufactures'
    )
  },
  GetManufactureById(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/manufacture/GetManufactureById?id=' + id
    )
  },
  AddorUpdateManufacture(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/manufacture/AddorUpdateManufacture',
      data: data
    })
  },
  GetProducts() {
    return apiClient.get(baseUrls['commonBaseUrl'] + '/product/GetProducts')
  },
  GetProductsById(userId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/product/GetProductsByUserId?userId=' +
        userId
    )
  },
  GetProductsByManufacturerId(manufacturerId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/product/GetProductsByManufacturerId?manufacturerId=' +
        manufacturerId
    )
  },
  GetProductBrands(manufacturerId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/product/GetProductBrands',
      { params: { manufacturerId } }
    )
  },
  GetProductOptions(manufacturerId, productBrandId) {
    const params = { manufacturerId }
    if (productBrandId !== undefined && productBrandId !== null) {
      params.productBrandId = productBrandId
    }
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/product/GetProductOptions',
      { params }
    )
  },
  SaveProductCatalogue(data) {
    return apiClient.post(
      baseUrls['commonBaseUrl'] + '/product/SaveProductCatalog',
      data
    )
  },
  GetProductDetailById(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/product/GetProductDetailById?id=' + id
    )
  },
  AddorUpdateProduct(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/product/AddorUpdateProduct',
      data: data
    })
  },
  GetProductThresholds() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/productthreshold/GetProductThresholds'
    )
  },
  GetProductThresholdsByProductId(productId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/productthreshold/GetProductThresholdsByProductId?productId=' +
        productId
    )
  },
  AddorUpdateProductThreshold(data) {
    return apiClient({
      method: 'post',
      url:
        baseUrls['commonBaseUrl'] +
        '/productthreshold/AddorUpdateProductThreshold',
      data: data
    })
  },
  CopyProductThreshold(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/productthreshold/CopyProductThreshold',
      data: data
    })
  },
  DeleteProductThreshold(id) {
    return apiClient.delete(
      baseUrls['commonBaseUrl'] +
        '/productthreshold/DeleteProductThreshold?productThresholdId=' +
        id
    )
  },
  GetPosition() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/productthreshold/GetPosition'
    )
  },
  GetPodCharacteristics() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/podcharacter/GetPodCharacteristics'
    )
  },
  AddorUpdatePodCharacteristics(data) {
    return apiClient({
      method: 'post',
      url:
        baseUrls['commonBaseUrl'] +
        '/podcharacter/AddorUpdatePodCharacteristics',
      data: data
    })
  },
  GetUserRoles(filterName) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/user/getusers?filterName=' + filterName
    )
  },
  GetRoles() {
    return apiClient.get(baseUrls['commonBaseUrl'] + '/role/getroles')
  },
  CreateUser(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/user/createuser',
      data: data
    })
  },
  UpdateUser(userId, data) {
    return apiClient({
      method: 'put',
      url: baseUrls['commonBaseUrl'] + '/user/UpdateUser?userId=' + userId,
      data: data
    })
  },
  ResetPassword(userId, data) {
    return apiClient({
      method: 'put',
      url: baseUrls['commonBaseUrl'] + '/user/ResetPassword?userId=' + userId,
      data: data
    })
  },
  UpdateUserRole(userId, roleId) {
    return apiClient({
      method: 'put',
      url: baseUrls['commonBaseUrl'] + '/role/UpdateUserRole?userId=' + userId,
      data: roleId
    })
  },
  GetRolePermission(roleId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/role/GetRolePermission?roleId=' + roleId
    )
  },
  SaveRolePermission(roleId, data) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['commonBaseUrl'] + '/role/saverolepermission?roleId=' + roleId,
      data: data
    })
  },
  DeleteRole(roleId) {
    return apiClient.delete(
      baseUrls['commonBaseUrl'] + '/role/DeleteRole?roleId=' + roleId
    )
  },
  GetMonitoring() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/production/GetMonitoring'
    )
  },
  GetTestReports(data) {
    let startDateTime = ''
    let endDateTime = ''
    if (data.date && data.date.length) {
      startDateTime = moment(data.date[0]).format('YYYY-MM-DD')
      endDateTime = moment(data.date[1]).format('YYYY-MM-DD')
    }
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/production/GetTestReports?podMac=' +
        data.podMac +
        '&testedBy=' +
        data.testedBy +
        '&hwVer=' +
        data.hwVer +
        '&fwVer=' +
        data.fwVer +
        '&startDateTime=' +
        startDateTime +
        '&endDateTime=' +
        endDateTime +
        '&result=' +
        data.result +
        '&assetNumber=' +
        data.assetNumber
    )
  },
  GetTestDetail(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/production/GetTestDetail?id=' + id
    )
  },
  SaveElectricalAcceptanceCriteria(data) {
    return apiClient({
      method: 'post',
      url:
        baseUrls['commonBaseUrl'] +
        '/production/SaveElectricalAcceptanceCriteria',
      data: data
    })
  },
  SaveFunctionalAcceptanceCriteria(data) {
    return apiClient({
      method: 'post',
      url:
        baseUrls['commonBaseUrl'] +
        '/production/SaveFunctionalAcceptanceCriteria',
      data: data
    })
  },
  GetFirmwares() {
    return apiClient.get(baseUrls['commonBaseUrl'] + '/firmware/getfirmwares')
  },
  MoveToProd(id) {
    return apiClient({
      method: 'put',
      url: baseUrls['commonBaseUrl'] + '/firmware/movetoprod?id=' + id
    })
  },
  MovetoStage(id) {
    return apiClient({
      method: 'put',
      url: baseUrls['commonBaseUrl'] + '/firmware/MovetoStage?id=' + id
    })
  },
  UploadFirmImgFile(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/firmware/uploadfirmimgfile',
      data: data,
      headers: { 'Content-Type': 'multipart/form-data' }
    })
  },
  GetAcceptanceCriteria() {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/production/GetAcptCriteria'
    )
  },
  GetManufacturerCodesByManufacturerId(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/Manufacture/GetManufacturerCodesByManufacturerId?manufacturerId=' +
        id
    )
  },
  CreateManufacturerCode(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/Manufacture/CreateManufacturerCode',
      data: data
    })
  },
  ApproveManufacturerCode(data) {
    return apiClient({
      method: 'put',
      url: baseUrls['commonBaseUrl'] + '/Manufacture/ApproveManufacturerCode',
      data: data
    })
  },
  ExpireManufacturerCode(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/Manufacture/ExpireManufacturerCode',
      data: data
    })
  },
  GetCapacitanceReadings(
    macFilter,
    startTime,
    endTime,
    inputUtcOffset,
    useProdApi = false
  ) {
    return apiClient.get(
      (useProdApi
        ? 'https://configs.smartzhealth.com/api'
        : baseUrls['commonBaseUrl']) +
        '/data/getcapacitancereadings?macFilter=' +
        macFilter +
        '&startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&inputUtcOffset=' +
        inputUtcOffset
    )
  },
  GetConnectionReadings(macFilter, startTime, endTime, inputUtcOffset) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/data/getconnectionreadings?macFilter=' +
        macFilter +
        '&startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&inputUtcOffset=' +
        inputUtcOffset
    )
  },
  GetBatteryReadings(macFilter, startTime, endTime, inputUtcOffset) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/data/getbatteryreadings?macFilter=' +
        macFilter +
        '&startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&inputUtcOffset=' +
        inputUtcOffset
    )
  },
  GetAccelerometerReadings(macFilter, startTime, endTime, inputUtcOffset) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/data/getaccelerometerreadings?macFilter=' +
        macFilter +
        '&startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&inputUtcOffset=' +
        inputUtcOffset
    )
  },
  GetTemperatureReadings(macFilter, startTime, endTime, inputUtcOffset) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/data/gettemperaturereadings?macFilter=' +
        macFilter +
        '&startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&inputUtcOffset=' +
        inputUtcOffset
    )
  },
  DownloadRawData(macFilter, startTime, endTime, utcOffset) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/data/download?macFilter=' +
        macFilter +
        '&startTime=' +
        startTime +
        '&endTime=' +
        endTime +
        '&inputUtcOffset=' +
        utcOffset +
        '&outputUtcOffset=' +
        utcOffset
    )
  },
  SaveDataTag(inputUtcOffset, data) {
    return apiClient({
      method: 'post',
      url:
        baseUrls['commonBaseUrl'] +
        '/characterisation/savedatatag?inputUtcOffset=' +
        inputUtcOffset,
      data: data
    })
  },
  GetCharacterizationByProduct(product) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/characterisation/getcharacterisationbyproductId?productId=' +
        product
    )
  },
  GetDataTags(filterPodMac, filterTag, filterNotesPod) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/characterisation/getdatatags?filterPodMac=' +
        filterPodMac +
        '&filterTag=' +
        filterTag +
        '&filterNotesPod=' +
        filterNotesPod
    )
  },
  GetDataTagById(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/characterisation/getdatatagbyid?id=' + id
    )
  },
  ExportDataTagById(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] + '/characterisation/exportdatatagbyid?id=' + id
    )
  },
  DeleteDataTagById(id) {
    return apiClient.delete(
      baseUrls['commonBaseUrl'] + '/characterisation/deletedatatagbyid?id=' + id
    )
  },
  SaveCharacterization(data) {
    return apiClient({
      method: 'post',
      url:
        baseUrls['commonBaseUrl'] + '/characterisation/savecharacterisationrun',
      data: data
    })
  },
  GetCharacterizationDetail(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/characterisation/getcharacterisationrun?id=' +
        id
    )
  },
  GetPadCharacterizationCommentById(id) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/characterisation/getpadcharacterisationCommentById?id=' +
        id
    )
  },
  GetPadCycleData(macFilter, offSet, filterDate, condition, bounds) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/data/GetPadCycleData?macFilter=' +
        macFilter +
        '&offSet=' +
        offSet +
        '&filterDate=' +
        filterDate +
        '&condition=' +
        condition +
        '&bounds=' +
        bounds
    )
  },
  EnableDisableClumping(id, isClumpingEnabled) {
    return apiClient({
      method: 'put',
      url:
        baseUrls['commonBaseUrl'] +
        '/productthreshold/EnableDisableClumping?id=' +
        id +
        '&isClumpingEnabled=' +
        isClumpingEnabled
    })
  },
  GetNodeList() {
    return apiClient.get(baseUrls['commonBaseUrl'] + '/node/GetAllConfigNodes')
  },
  UpdateNodeConfig(data) {
    return apiClient({
      method: 'post',
      url: baseUrls['commonBaseUrl'] + '/node/updatenodeconfig',
      data: data
    })
  },
  GetPadCycleDataWithId(padCycleId) {
    return apiClient.get(
      baseUrls['commonBaseUrl'] +
        '/data/GetPadCycleDataById?padCycleId=' +
        padCycleId
    )
  }
}
